/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

const React = require('react')
const { ThemeProvider } = require('styled-components')

require('@fontsource/kanit')
require('@fontsource/kanit/200.css')
require('@fontsource/kanit/500.css')
require('@fontsource/kanit/700.css')
require('@fontsource/kanit/900.css')

const { default: theme } = require('styles/theme')
const { default: GlobalStyles } = require('styles/global')
const { PopupProvider } = require('contexts/popup')

exports.wrapRootElement = ({ element }) => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <PopupProvider>{element}</PopupProvider>
      </ThemeProvider>
    </>
  )
}
